import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDistributionByLocation, getRegionCount } from '../../../../redux/thunks/affinityHubThunk';
import { Grid, Box, Typography, Skeleton } from '@mui/material';
import {
    CustomButton,
    USACountryChart,
    HighchartBarChart,
} from '../../../shared';
import { DISTRIBUTION_CHART_OPTIONS, USA_CHART_OPTIONS } from './constants';

const DistributionByLocation = (props) => {
    const {} = props;
    const dispatch = useDispatch();
    const { distributionByLocation } = useSelector(
        (state) => state.affinityHub
    );
    const { mapSeries, chartSeries, totalCount, isLoading, top15Total } =
        distributionByLocation;

    useEffect(() => {
        dispatch(getDistributionByLocation());
        dispatch(getRegionCount());
    }, []);

    return (
        <Box className="box-sizing-border-box padding-24px">
            <Box className="padding-tb-20-rl-0 border-bottom-gray">
                <Box className="flex-row">
                    <Box>
                        <Typography className="text-md-semi-bold gray-900">
                            Distribution by Location
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Grid container className="pt-20px flex-row-center">
                <Grid item xs={12} sm={12} md={12} lg={7} xl={8}>
                    {/* Location Chart */}
                    {isLoading ? (
                        <Skeleton
                            variant="rounded"
                            width={'90%'}
                            height={400}
                        />
                    ) : (
                        <USACountryChart
                            chartOptions={USA_CHART_OPTIONS}
                            mapSeries={mapSeries}
                        />
                    )}
                </Grid>

                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={5}
                    xl={4}
                    className="padding-24px bg-gray-50 br-16px"
                >
                    {/* Location Info */}
                    <Box className="flex-column gap-4">
                        <Typography className="text-md-semi-bold gray-900">
                            Top {chartSeries?.length > 15 ? "15" : chartSeries?.length === 0 ? "" : chartSeries?.length} States by HCPs
                        </Typography>
                    </Box>
                    <Box className="pt-24px">
                        {isLoading ? (
                            <Skeleton
                                variant="rounded"
                                width={'100%'}
                                height={270}
                            />
                        ) : (
                            <HighchartBarChart
                                chartOptions={{
                                    ...DISTRIBUTION_CHART_OPTIONS,
                                    chart: {
                                        ...DISTRIBUTION_CHART_OPTIONS.chart,
                                    },
                                }}
                                seriesData={chartSeries?.slice(0, 15)}
                                seriesName="Affinity Hub Top States by individuals"
                            />
                        )}
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default DistributionByLocation;
